
export function decodeEntities(str = "") {
    if (!str) return "";

    return (str || "")
        .replace(/&nbsp;/g, " ")
        .replace(/&amp;/g, "&")
        .replace(/&lt;/g, "<")
        .replace(/&gt;/g, ">")
        .replace(/&quot;/g, '"')
        .replace(/&#39;/g, "'");
}

export function htmlToFacebookText(html = "") {
  if (!html) return "";

  let s = decodeEntities(html);

  // --- HEADINGS ---
  s = s.replace(/<(h[1-6])[^>]*>(.*?)<\/\1>/gi, (_, __, inner) => {
    const text = stripTags(inner).toUpperCase();
    return `\n\n${text}\n\n`;
  });

  // --- PARAGRAPHS & BREAKS ---
  s = s
    .replace(/<(br|BR)\s*\/?>/g, "\n")
    .replace(/<\/p>/gi, "\n\n")
    .replace(/<p[^>]*>/gi, "");
    // --- ORDERED LISTS ---
    s = s.replace(/<ol[^>]*>([\s\S]*?)<\/ol>/gi, (match, inner) => {
      let i = 1;
      const items = inner.replace(/<li[^>]*>([\s\S]*?)<\/li>/gi, (_, item) => {
        return `${i++}. ${stripTags(item)}\n`;
      });
      return `${items}\n`;
    });

    // --- UNORDERED LISTS ---
    s = s.replace(/<ul[^>]*>([\s\S]*?)<\/ul>/gi, (match, inner) => {
      const items = inner.replace(/<li[^>]*>([\s\S]*?)<\/li>/gi, (_, item) => {
        return `• ${stripTags(item)}\n`;
      });
      return `${items}\n`;
    });

  // --- TABLES ---
  s = s.replace(/<\/tr>/gi, "\n");
  s = s.replace(/<\/t[dh]>/gi, " | ");
  s = s.replace(/<t[dh][^>]*>/gi, "");
  s = s.replace(/<(tr|table|tbody|thead)[^>]*>/gi, "");

  // --- BLOCKQUOTE ---
  s = s.replace(/<blockquote[^>]*>([\s\S]*?)<\/blockquote>/gi, (_, inner) => {
    return `\n“${stripTags(inner)}”\n`;
  });

  // --- CODE / PRE ---
  s = s.replace(/<pre[^>]*>([\s\S]*?)<\/pre>/gi, (_, inner) => {
    return `\n[code]\n${stripTags(inner)}\n[/code]\n`;
  });
  s = s.replace(/<code[^>]*>([\s\S]*?)<\/code>/gi, (_, inner) => {
    return `\`${stripTags(inner)}\``;
  });

  // --- LINKS ---
  s = s.replace(/<a[^>]*href="([^"]+)"[^>]*>([\s\S]*?)<\/a>/gi, (_, hrefRaw, inner) => {
    const text = stripTags(inner).trim();
    const href = hrefRaw.trim();

    const normalize = (u) => {
      // protocol-relative → prefer https
      if (/^\/\//.test(u)) return `https:${u}`;
      // already has http(s):// → normalize to https://
      if (/^https?:\/\//i.test(u)) return u.replace(/^http:\/\//i, "https://");
      // mailto, tel or anchor → leave as-is
      if (/^(mailto:|tel:)/i.test(u)) return u;
      if (/^#/i.test(u)) return u;
      // no protocol → default to https
      return `https://${u}`;
    };

    const stripForCompare = (u = "") =>
      u
        .toString()
        .replace(/^https?:\/\//i, "")
        .replace(/^\/\//, "")
        .replace(/\/$/, "")
        .replace(/^www\./i, "")
        .trim()
        .toLowerCase();

    const url = normalize(href);

    if (!text) return url;
    // if the link text already is the same URL (considering protocol/www differences), just return the URL
    if (text === href || text === url) return url;
    if (stripForCompare(text) === stripForCompare(href) || stripForCompare(text) === stripForCompare(url)) return url;

    return `${text}: ${url}`;
  });


  // --- IMAGES ---
  s = s.replace(/<img[^>]*>/gi, (tag) => {
    const altMatch = tag.match(/alt="([^"]*)"/i);
    const srcMatch = tag.match(/src="([^"]*)"/i);
    const alt = altMatch ? altMatch[1].trim() : "";
    const src = srcMatch ? srcMatch[1].trim() : "";
    if (alt && src) return `[${alt}] (${src})`;
    if (alt) return `[${alt}]`;
    if (src) return `Image: ${src}`;
    return "[Image]";
  });

  // --- BOLD & ITALIC ---
  const boldMap = (str) =>
    str.replace(/[A-Za-z0-9]/g, (c) => {
      const code = c.charCodeAt(0);
      if (code >= 65 && code <= 90) return String.fromCodePoint(0x1d400 + (code - 65));
      if (code >= 97 && code <= 122) return String.fromCodePoint(0x1d41a + (code - 97));
      if (code >= 48 && code <= 57) return String.fromCodePoint(0x1d7ce + (code - 48));
      return c;
    });

  const italicMap = (str) =>
    str.replace(/[A-Za-z]/g, (c) => {
      const code = c.charCodeAt(0);
      if (code >= 65 && code <= 90) return String.fromCodePoint(0x1d434 + (code - 65));
      if (code >= 97 && code <= 122) return String.fromCodePoint(0x1d44e + (code - 97));
      return c;
    });

  s = s.replace(/<(strong|b)[^>]*>(.*?)<\/\1>/gi, (_, __, inner) => boldMap(stripTags(inner)));
  s = s.replace(/<(em|i)[^>]*>(.*?)<\/\1>/gi, (_, __, inner) => italicMap(stripTags(inner)));

  // --- VIDEOS (iframe, video, embed) ---
  s = s.replace(/<iframe[^>]*src="([^"]+)"[^>]*><\/iframe>/gi, "Video: $1");
  s = s.replace(/<video[^>]*src="([^"]+)"[^>]*>.*?<\/video>/gi, "Video: $1");
  s = s.replace(/<embed[^>]*src="([^"]+)"[^>]*>/gi, "Media: $1");

  // --- STRIP remaining tags ---
  s = stripTags(s);

  // --- CLEANUP ---
  s = s.replace(/\u00A0/g, " "); // non-breaking space → normal
  s = s
    .split("\n")
    .map((line) => line.replace(/\s+/g, " ").trim())
    .join("\n")
    .replace(/\n{3,}/g, "\n\n")
    .trim();

  return s;
}

export function stripTags(input = "") {
  return input.replace(/<\/?[^>]+(>|$)/g, "");
}

